import {useState} from "react";



export function useLocalStorageState(key:string, defaultValue:boolean) {

    const storedValue = localStorage.getItem(key);
    const initialValue = storedValue !== null ? JSON.parse(storedValue) : defaultValue;

    const [state, setState] = useState(initialValue);

    const setValue = (newValue: string) => {
        setState(newValue);
        localStorage.setItem(key, JSON.stringify(newValue));
    };

    return [state, setValue]
}